module.exports = __webpack_public_path__ + "img/ea04027.png";